// Libs
import { css } from 'styled-components'

// Comps
import { colors, fontWeights, mobileScreen } from '../../utils'
import { clearButtonStyles, px } from '../../utils/styles'

export const emailRSVPEventModalStyles = css`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-width: 0px;
  max-width: 350px;
  height: auto;
  /* max-height: 80vh; */
  min-height: auto;

  padding-top: 0px;
  padding-bottom: 40px;
  padding-left: 25px;
  padding-right: 25px;

  ${mobileScreen(css`
    width: calc(100% - 40px);
    max-width: 100%;
    margin-left: 20px;
    margin-right: 20px;
  `)}

  .badge {
    display: block;
    width: 94px;
    height: 94px;
    margin: auto;
    margin-bottom: 15px;
  }

  .header {
    display: block;

    margin-left: -25px;
    margin-right: -25px;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 25px;
    padding-right: 40px; /** Clear close button */

    border-bottom: 1px solid ${colors.lightGray};
    font-weight: ${fontWeights.semiBold};
  }

  p {
    margin-top: 25px;
  }

  .formField {
    margin-top: 25px;

    .title {
      text-transform: uppercase;
    }
  }

  /* .reminder-text {
    width: 100%;
    max-width: 305px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  } */

  .actions {
    margin-top: 32px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .login {
    display: block;
    text-align: center;
  }

  .submit {
    text-align: center;
    display: block;
    margin-top: 40px;
    margin-left: 8px;
  }

  .server-error-message {
    margin-top: 10px;
    text-align: center;
  }
`
